import type {
	AnalyticsEvent,
	AnalyticsOptions,
	AnalyticsParams,
	AnalyticsPlatform,
} from "./types";

declare global {
	interface Window {
		fbq?: (...args: unknown[]) => void;
		_fbq?: (...args: unknown[]) => void;
	}
}

let initialized = false;

const EVENT_MAP: Record<AnalyticsEvent, string> = {
	page_view: "PageView",
	view_content: "ViewContent",
	add_to_cart: "AddToCart",
	initiate_checkout: "InitiateCheckout",
	lead: "Lead",
	complete_registration: "CompleteRegistration",
	purchase: "Purchase",
};

function isEnabled() {
	const value = (import.meta.env.VITE_ENVIRONMENT ?? "")
		.toString()
		.trim()
		.toLowerCase();
	return value === "prod" || value === "production";
}

export const metaPlatform: AnalyticsPlatform = {
	init() {
		if (typeof window === "undefined" || initialized) return;
		if (!isEnabled()) return;

		const pixelId = import.meta.env.VITE_META_PIXEL_ID;
		if (!pixelId) return;

		(function (f: Window, b: Document, e: string, v: string) {
			if (f.fbq) return;
			const n: any = function (...args: unknown[]) {
				if (n.callMethod) {
					n.callMethod.apply(n, args);
				} else {
					n.queue.push(args);
				}
			};
			f.fbq = n;
			if (!f._fbq) f._fbq = n;
			n.push = n;
			n.loaded = true;
			n.version = "2.0";
			n.queue = [];
			const t = b.createElement(e) as HTMLScriptElement;
			t.async = true;
			t.src = v;
			const s = b.getElementsByTagName(e)[0];
			s.parentNode?.insertBefore(t, s);
		})(
			window,
			document,
			"script",
			"https://connect.facebook.net/en_US/fbevents.js"
		);

		window.fbq?.("init", pixelId);
		initialized = true;
	},

	track(
		event: AnalyticsEvent,
		params?: AnalyticsParams,
		options?: AnalyticsOptions
	) {
		if (typeof window === "undefined") return;
		if (!isEnabled()) return;
		const fbqEvent = EVENT_MAP[event];
		window.fbq?.("track", fbqEvent, params ?? {}, options ?? {});
	},
};
